module.exports = __webpack_public_path__ + "media/images/emblems/Sorens-coat_of_arms-f22c2e4edd279c3c02bcdf42fbb1c3df.svg";